/**
TODO: this is a fake control and doesn't really render items in tabs
*/
import $ = require("jquery");
import _ = require("underscore");
import Mediator = require("../mediator");
import Utils = require("../utils");
import Portal = require("portal-gis");
import TabsView = require("../views/TabsView");
import TabsItemCollection = require("../collections/tabs-collection");
import View = require("./view");

class Control extends View {
  static about = `
This is an incomplete test control that does not render items in tabs but simply renders them in a list.

<details>
<summary>Usage Example:</summary>

\`\`\`xml
<CONTROL id="geoquery-form" mid="app/controls/tabs" text="Queries" type="container">
  <OPTIONS>
    <Values id="region" value="filter-region" />
  </OPTIONS>
  <CONTROLS>
    <CONTROL id="ags-geoquery-form-tool-sf311" mid="app/controls/ags-geoquery-form-tool" text="San Francisco 311" type="execute">
      <OPTIONS>
        <Values id="url" value="//sampleserver6.arcgisonline.com/arcgis/rest/services/SF311/FeatureServer/0" />
        <Values id="symbology" value="sf311" />
        <Values id="key-template" value="&lt;%=objectid%&gt;" />
        <Values id="whitelist" value="req_type,status" />
      </OPTIONS>
      <COMMANDS>
        <COMMAND id="geoquery-form-search" mid="app/commands/trigger" text="Search" type="action">
          <OPTIONS>
            <Values id="event" value="ags-geoquery-execute" />
          </OPTIONS>
        </COMMAND>
      </COMMANDS>
      <CONTROLS>
        <CONTROL about="Execute this query:&#xD;&#xA;&#xD;&#xA;http://sampleserver6.arcgisonline.com/arcgis/rest/services/SF311/FeatureServer/0/query?where=1=1&amp;outFields=req_type&amp;returnGeometry=false&amp;returnDistinctValues=true&amp;f=pjson" id="req_type" mid="app/test/controls/ags/domain" text="Request Type">
          <OPTIONS>
            <Values id="url" value="http://sampleserver6.arcgisonline.com/arcgis/rest/services/SF311/FeatureServer/0/query?where=1=1&amp;outFields=req_type&amp;returnGeometry=false&amp;returnDistinctValues=true&amp;f=pjson" />
            <Values about="Query for multiple requests types at one time" id="multi-select" value="true" />
          </OPTIONS>
        </CONTROL>
      </CONTROLS>
    </CONTROL>
    <CONTROL id="ogcwfs-geoquery-form-tool-usstates" mid="app/controls/ogcwfs-geoquery-form-tool" text="US States" type="execute">
      <OPTIONS>
        <Values id="url" value="//usgvdcalix01:8080/geoserver/wfs" />
        <Values id="typeName" value="usa:states" />
        <Values id="symbology" value="usa:states" />
        <Values id="key-template" value="&lt;%=STATE_ABBR%&gt;" />
        <Values id="blacklist" value="MALE,FEMALE,PERSONS,STATE_NAME" />
      </OPTIONS>
      <COMMANDS>
        <COMMAND id="geoquery-form-search" mid="app/commands/trigger" text="Search" type="action">
          <OPTIONS>
            <Values id="event" value="ogc-geoquery-execute" />
          </OPTIONS>
        </COMMAND>
      </COMMANDS>
    </CONTROL>
    <CONTROL id="ags-geoquery-form-tool-military-lines" mid="app/controls/ags-geoquery-form-tool" text="Military Lines" type="execute">
      <OPTIONS>
        <Values id="url" value="//sampleserver6.arcgisonline.com/arcgis/rest/services/Military/FeatureServer/4" />
        <Values id="key-template" value="&lt;%=objectid%&gt;" />
        <Values id="blacklist" value="ruleid,azimuth,datetimevalid,datetimeexpired,eny,objectid,additionalinformation" />
      </OPTIONS>
      <COMMANDS>
        <COMMAND id="geoquery-form-search" mid="app/commands/trigger" text="Search" type="action">
          <OPTIONS>
            <Values id="event" value="ags-geoquery-execute" />
          </OPTIONS>
        </COMMAND>
      </COMMANDS>
    </CONTROL>
    <CONTROL disabled="False" id="cdr-date-range-filter" mid="app/controls/ips-geoquery-form-tool" text="CDR Date Range Filter" type="execute">
      <OPTIONS>
        <Values id="service" value="resource/cdr" />
        <Values id="service-model" value="Application" />
        <Values id="query-service" value="cdr/applications/building,cdr/applications/use,cdr/applications/codeenforcement,cdr/applications/businesslicense" />
        <Values id="srs" value="EPSG:3421" />
        <Values id="symbology" value="status" />
        <Values id="zoommap" value="false" />
        <Values about="Only show this one date field" id="whitelist" value="ApplicationDateTime,Status" />
      </OPTIONS>
      <COMMANDS>
        <COMMAND id="geoquery-form-search" mid="app/commands/trigger" text="Search" type="action">
          <OPTIONS>
            <Values id="event" value="ips-geoquery-execute" />
          </OPTIONS>
        </COMMAND>
      </COMMANDS>
      <CONTROLS>
        <CONTROL about="Replaces the default input control with a date range control" id="ApplicationDateTime" mid="app/test/controls/daterange" text="Expiration Date">
          <OPTIONS>
            <Values about="days ago" id="default-lo" value="-14" />
            <Values about="days ahead of today" id="default-hi" value="14" />
          </OPTIONS>
        </CONTROL>
        <CONTROL about="Display checkboxes or radio buttons instead of the default input control for selecting one or more status values" id="Status" mid="app/test/controls/domain" text="Status Filter">
          <OPTIONS>
            <Values about="Could add Attributes to commands, could introduce a &quot;model&quot; option, could dedicate options to the domain values, could do delimited value on &quot;domain&quot; but this covers the need of non-numeric domain keys and and allows for other options to be provided." id="domain" value="{&#xD;&#xA;    &quot;Open&quot;: &quot;open&quot;,&#xD;&#xA;    &quot;Closed&quot;: &quot;closed&quot;,&#xD;&#xA;    &quot;Inactive&quot;: &quot;0&quot;,&#xD;&#xA;    &quot;Active&quot;: 1&#xD;&#xA;}" />
            <Values about="show checkboxes instead of radio buttons" id="multi-select" value="true" />
            <Values id="domain-default" value="open,closed" />
          </OPTIONS>
        </CONTROL>
        <CONTROL about="Display checkboxes or radio buttons instead of the default input control for selecting one or more status values" id="WorkType" mid="app/test/controls/domain" text="Work Type">
          <OPTIONS>
            <Values about="Valid WorkType values for a CDR application" id="domain" value="{&#xD;&#xA;    &quot;Open&quot;: &quot;open&quot;,&#xD;&#xA;    &quot;Closed&quot;: &quot;closed&quot;&#xD;&#xA;}" />
            <Values about="show checkboxes instead of radio buttons" id="multi-select" value="false" />
          </OPTIONS>
        </CONTROL>
      </CONTROLS>
    </CONTROL>
    <CONTROL disabled="False" id="cdr-application-filter" mid="app/controls/ips-geoquery-form-tool" text="CDR Application" type="execute">
      <OPTIONS>
        <Values id="service" value="resource/cdr" />
        <Values id="service-model" value="Application" />
        <Values id="query-service" value="cdr/applications/planning" />
        <Values id="srs" value="EPSG:3421" />
        <Values id="symbology" value="Hansen.CDR.Planning.Inspection" />
        <Values id="zoommap" value="false" />
        <Values about="Only these fields may appear on the form and only if they are enabled and not blacklisted" id="whitelist" value="ApplicationDateTime,ApplicationName,Comments,ExpireDateTime,Status,TotalUnpaidFees,Type,WorkType" />
        <Values about="These fields will not show on this form" id="blacklist" value="DeclaredValuation,LastModifiedDateTime" />
      </OPTIONS>
      <COMMANDS>
        <COMMAND id="geoquery-form-search" mid="app/commands/trigger" text="Search" type="action">
          <OPTIONS>
            <Values id="event" value="ips-geoquery-execute" />
          </OPTIONS>
        </COMMAND>
      </COMMANDS>
      <CONTROLS>
        <CONTROL about="Replaces the default input control with a date range control" id="ExpireDateTime" mid="app/test/controls/daterange" text="Expiration Date">
          <OPTIONS>
            <Values id="default-lo" value="-14" />
            <Values id="default-hi" value="14" />
          </OPTIONS>
        </CONTROL>
        <CONTROL about="Replaces the default input control with a fancy-pants editor" id="Comments" mid="app/test/controls/editor" text="Comments?">
          <OPTIONS>
            <Values id="default-value" value="[hello]" />
          </OPTIONS>
        </CONTROL>
        <CONTROL about="Display checkboxes or radio buttons instead of the default input control for selecting one or more status values" id="Status" mid="app/test/controls/domain" text="Status Filter">
          <OPTIONS>
            <Values about="Could add Attributes to commands, could introduce a &quot;model&quot; option, could dedicate options to the domain values, could do delimited value on &quot;domain&quot; but this covers the need of non-numeric domain keys and and allows for other options to be provided." id="domain" value="{&#xD;&#xA;    &quot;Open&quot;: &quot;open&quot;,&#xD;&#xA;    &quot;Closed&quot;: &quot;closed&quot;,&#xD;&#xA;    &quot;Inactive&quot;: &quot;0&quot;,&#xD;&#xA;    &quot;Active&quot;: 1&#xD;&#xA;}" />
            <Values about="show checkboxes instead of radio buttons" id="multi-select" value="true" />
            <Values id="domain-default" value="open,closed" />
          </OPTIONS>
        </CONTROL>
        <CONTROL about="Display checkboxes or radio buttons instead of the default input control for selecting one or more status values" id="WorkType" mid="app/test/controls/domain" text="Work Type">
          <OPTIONS>
            <Values about="Valid WorkType values for a CDR application" id="domain" value="{&#xD;&#xA;    &quot;Open&quot;: &quot;open&quot;,&#xD;&#xA;    &quot;Closed&quot;: &quot;closed&quot;&#xD;&#xA;}" />
            <Values about="show checkboxes instead of radio buttons" id="multi-select" value="false" />
          </OPTIONS>
        </CONTROL>
        <CONTROL about="Disable this field as if it were blacklisted or just disable this override?" disabled="True" id="IssuedDateTime" mid="app/test/controls/daterange" text="Date Issued" />
        <CONTROL about="Relabel this field" disabled="False" id="ProcessState" mid="app/test/controls/editor" text="Process State" />
      </CONTROLS>
    </CONTROL>
    <CONTROL disabled="False" id="property-address-filter" mid="app/controls/ips-geoquery-form-tool" text="Property Address" type="execute">
      <OPTIONS>
        <Values id="service" value="resource/property" />
        <Values id="service-model" value="Address" />
        <Values id="query-service" value="property/addresses" />
        <Values id="symbology" value="Hansen.Property.Address" />
        <Values id="srs" value="EPSG:3857" />
        <Values id="panmap" value="true" />
        <Values id="whitelist" value="City,PostalCode,Region,StreetName,StreetNumber" />
      </OPTIONS>
      <COMMANDS>
        <COMMAND id="geoquery-form-search" mid="app/commands/trigger" text="Search" type="action">
          <OPTIONS>
            <Values id="event" value="ips-geoquery-execute" />
          </OPTIONS>
        </COMMAND>
      </COMMANDS>
    </CONTROL>
    <CONTROL disabled="False" id="crm-servicerequests" mid="app/controls/ips-geoquery-form-tool" text="Service Requests" type="execute">
      <OPTIONS>
        <Values id="service" value="resource/crm" />
        <Values id="service-model" value="ServiceRequest" />
        <Values id="query-service" value="crm/servicerequests" />
        <Values id="srs" value="EPSG:3857" />
        <Values id="symbology" value="Hansen.CRM.ServiceRequest" />
        <Values id="whitelist" value="ReferenceNumber,RequestDate" />
      </OPTIONS>
      <COMMANDS>
        <COMMAND id="geoquery-form-search" mid="app/commands/trigger" text="Search" type="action">
          <OPTIONS>
            <Values id="event" value="ips-geoquery-execute" />
          </OPTIONS>
        </COMMAND>
      </COMMANDS>
      <CONTROLS>
        <CONTROL about="Replaces the default input control with a date range control" id="RequestDate" mid="app/test/controls/daterange" text="Request Range">
          <OPTIONS>
            <Values about="days ago" id="default-lo" value="-30" />
            <Values about="days ahead of today" id="default-hi" value="0" />
          </OPTIONS>
        </CONTROL>
      </CONTROLS>
    </CONTROL>
    <CONTROL id="ags-parcel-filter" mid="app/controls/ags-geoquery-form-tool" text="Parcels" type="execute">
      <OPTIONS>
        <Values id="url" value="//usalvwdgis1:6080/arcgis/rest/services/Vegas/MapVegas850/MapServer/18" />
        <Values id="symbology" value="Hansen.Property.Parcels" />
        <Values id="key-template" value="&lt;%=objectid%&gt;" />
        <Values id="whitelist" value="PRCLID,PRCLNAME,PRCLNO,ZIPCODE" />
      </OPTIONS>
      <COMMANDS>
        <COMMAND id="geoquery-form-search" mid="app/commands/trigger" text="Search" type="action">
          <OPTIONS>
            <Values id="event" value="ags-geoquery-execute" />
          </OPTIONS>
        </COMMAND>
      </COMMANDS>
    </CONTROL>
  </CONTROLS>
</CONTROL>
\`\`\`
</details>

`;

  public view: TabsView;

  static init(region: string, options: Portal.ControlLeaf) {
    // Rhythm Liferay (RL) initializes a widget, which creates a layout-view in the `region`.
    // the layout-view is a container with one or more regions for showing widget-views.
    var config = _.extend({}, options);
  }

  createView() {
    let mediator = this.mediator;
    // create a view
    // this is a jquery tabs control so the template is well-known
    // use default template
    let viewOptions = this.setViewOptions({});
    let view = (this.view = new TabsView(this, viewOptions));

    // create a model
    view.collection = new TabsItemCollection();

    // setup command forwarding (view -> mediator)
    view.on("command", (args) => this.trigger("command", args));

    // setup tabs forwarding
    view.on("activate", (args) => {
      var $tabs = <JQuery>view["$tabs"];
      var activeTabIndex = $tabs.tabs("option", "active");
      var activeTab = $($tabs.find(">div")[activeTabIndex]);
      var id = activeTab.attr("id").substring("tabbody-".length);
      var activeModel = view.collection.get(id);

      var tabState = {
        controller: this,
        tab: activeTab,
        form: activeTab.find("form"),
        model: activeModel,
      };

      mediator.model.set("tabs-activate", tabState);
      mediator.trigger("tabs-activate", tabState);
    });

    // TODO: move elsewhere (where?)
    mediator.on(
      "add-to-geoquery-result-tab",
      (args: {
        out: {
          view: any;
        };
      }) => {
        this.view.addTab(
          {},
          {
            body: args.out.view.render().$el,
          }
        );
      }
    );

    this.broadcast();
    this.register();
  }

  // wrapper for a jquery-ui tabs control
  constructor(control: Portal.ControlLeaf, mediator: Mediator, args = {}) {
    // register controls, events, commands
    super(control, mediator, args);

    // I hate doing this but I don't know how else to get at it
    mediator.model.set(control.id, this);
  }

  addChild(controller: View) {
    if (!this.view) {
      this.createView();
    }

    if (controller.view) {
      this.view.addTab(controller.configuration, {
        body: controller.view.render().$el,
      });
    }
  }

  registerControls(controls: Portal.ControlsElement) {
    // allow app to instantiate and start view controller
    controls.Controls.filter((c) => !!c.type).forEach((c) => {
      switch (c.type) {
        case "form": {
          let form = Utils.extend(c).form;
          this.view.addTab(c, { body: form });
          break;
        }

        case "template": {
          let options = Utils.asDictionary(c.Options.Values);
          Utils.ifOption(options, "template", (template) => {
            Utils.withTemplate(template, (template) => {
              if (!template) {
                console.warn("template not found");
                return;
              }
              this.view.addTab(c, {
                body: template(c),
              });
            });
          });
          break;
        }

        default:
          break;
      }
    });

    return super.registerControls(controls);
  }
}

export = Control;
